module.exports = __webpack_public_path__ + "img/icon-package.104a64f2.svg";